export default {
  url: process.env.VUE_APP_URL,
  url1: process.env.VUE_APP_URL1
};

//export default {
//  url: "",
//  url1: "/api/"
//};
